import { render, staticRenderFns } from "./RevenueListPage.vue?vue&type=template&id=13ee96d7"
import script from "./RevenueListPage.vue?vue&type=script&lang=ts"
export * from "./RevenueListPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports